// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// Hatch — tiny DOM helpers.

const ESC: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/** Escape user/peer-supplied text before it goes into innerHTML. */
export function escapeHtml(s: string): string {
  return String(s).replace(/[&<>"']/g, (c) => ESC[c]);
}

/** Format an integer score with thousands separators. */
export function fmtScore(n: number): string {
  return Math.round(n).toLocaleString('en-US');
}

/** A short elapsed/countdown label from milliseconds, e.g. "42.6s" or "1:07". */
export function fmtTime(ms: number): string {
  const t = Math.max(0, ms);
  const totalS = Math.floor(t / 1000);
  if (totalS < 60) {
    const d = Math.floor((t % 1000) / 100);
    return `${totalS}.${d}s`;
  }
  const m = Math.floor(totalS / 60);
  const s = totalS % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}
